var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "table",
      staticClass: "c-table",
      class: {
        "c-table_scrolled": _vm.isScrolled,
        "c-table_scrolled_right":
          !_vm.isScrollEnd && !_vm.data.actions && _vm.isScroll,
        "c-table_scroll_end": _vm.isScrollEnd,
        "c-table_scroll": _vm.isScroll,
      },
    },
    [
      _vm.shouldDisplayRecord
        ? _c("div", {
            class: {
              "c-table__shadow": _vm.data.actions,
              "c-table__shadow__finance": _vm.data.type === "finance",
              "c-table__shadow__inventory-items-positions":
                _vm.data.type === "inventory-items-positions",
              "c-table__shadow__documents":
                _vm.data.type === "documents-archive" ||
                _vm.data.type === "documents-acting-documents",
              "c-table__shadow_active": _vm.data.actions,
              // 'c-table__empty__shadow': data.isGroupByCategory && hideCollapseGroups.length === data.records.length
            },
          })
        : _vm._e(),
      _vm.isScroll
        ? _c("div", { staticClass: "c-table__scrollbar-wrapper" })
        : _vm._e(),
      _c(
        "perfect-scrollbar",
        {
          ref: "wrapper" + (_vm.id !== undefined ? _vm.id : ""),
          staticClass: "c-table__wrapper",
          on: { scroll: _vm.scroll },
        },
        [
          _c(
            "table",
            { ref: "container", staticClass: "c-table__container" },
            [
              _c(
                "thead",
                { ref: "header", staticClass: "c-table__header" },
                _vm._l(_vm.levels, function (i) {
                  return _c(
                    "tr",
                    { key: i, staticClass: "c-table__header-row" },
                    [
                      _vm._l(_vm.getTableColumns(i), function (column) {
                        return _c(
                          "th",
                          {
                            key: column.id,
                            staticClass: "c-table__column",
                            class: {
                              "c-table__column_with_filter": column.type,
                              "c-table__column_hidden": _vm.isDisabled(
                                column.id
                              ),
                              "c-table__column_sorted": _vm.isSorted(column),
                            },
                            style: { width: column.width ? column.width : "" },
                            attrs: {
                              id: `c-table-column-${column.id}`,
                              colspan:
                                column.colspan === undefined
                                  ? _vm.getColspan(column)
                                  : column.colspan,
                              rowspan: _vm.getRowspan(column),
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-table__column-wrapper" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "c-table__column-label",
                                    class: {
                                      "c-table__column-label-children":
                                        !_vm.isCategory(column) &&
                                        _vm.sortedColumn,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.setSortedColumn(
                                          column,
                                          _vm.sortedColumn
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(column.label) + " ")]
                                ),
                                column.description || column.type
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "c-table__column-actions",
                                      },
                                      [
                                        column.fullName
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-action c-table__column-action_description",
                                              },
                                              [
                                                _c("c-button", {
                                                  attrs: {
                                                    id: `table-column-button-description-${column.id}`,
                                                    size: "small",
                                                    icon: "info",
                                                    "no-border": "",
                                                  },
                                                }),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      triggers: "hover",
                                                      target: `table-column-button-description-${column.id}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          column.fullName
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.isColumnFiltered(column.id)
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-action",
                                              },
                                              [
                                                _c("c-button", {
                                                  attrs: {
                                                    id: `table-column-button-filter-${column.id}`,
                                                    size: "small",
                                                    "no-border": "",
                                                    active:
                                                      _vm.isColumnActiveFiltered(
                                                        column.id
                                                      ),
                                                    icon: {
                                                      icon: "filter-column",
                                                      activeColor: "blue",
                                                    },
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openColumnFilterModal(
                                                        column
                                                      )
                                                    },
                                                  },
                                                }),
                                                _c(
                                                  "b-popover",
                                                  {
                                                    attrs: {
                                                      placement: "top",
                                                      triggers: "hover",
                                                      target: `table-column-button-filter-${column.id}`,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.isColumnActiveFiltered(
                                                            column.id
                                                          )
                                                            ? "Изменить фильтр"
                                                            : "Применить фильтр"
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      _vm.data.actions && i === 1
                        ? _c(
                            "th",
                            {
                              staticClass:
                                "c-table__column c-table__column_actions",
                              attrs: {
                                id: "c-table-actions-element",
                                rowspan: _vm.levels,
                              },
                            },
                            [
                              _c("div", {
                                staticClass: "c-table__column-empty",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                0
              ),
              !_vm.data.isGroupByCategory
                ? _c(
                    "tbody",
                    { staticClass: "c-table__records" },
                    _vm._l(_vm.sortedRecords, function (record, recordIndex) {
                      return _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: record.isShowRow,
                              expression: "record.isShowRow",
                            },
                          ],
                          key: recordIndex,
                          staticClass: "c-table__record",
                          class: {
                            "c-table__record__red":
                              (_vm.data.type === "discipline" &&
                                (record.explanatory.value === "need_write" ||
                                  record.explanatory.value === "expired" ||
                                  record.explanatory.value ===
                                    "issued_fine")) ||
                              (_vm.data.type === "inventory-items-positions" &&
                                record.status.desc === "issuedoverdue"),
                            "c-table__record__yellow":
                              _vm.data.type === "inventory-items-positions" &&
                              record.status.desc === "notissued",
                            "c-table__record__grey":
                              record.isSumRow !== undefined && record.isSumRow,
                          },
                        },
                        [
                          _vm._l(
                            _vm.getTableColumns(_vm.levels),
                            function (column, cellIndex) {
                              return [
                                _c(
                                  "td",
                                  {
                                    key: `cell-${cellIndex}`,
                                    staticClass: "c-table__cell",
                                    class: {
                                      // 'c-table__cell__red': (column.id === 'fotFromProceeds' || column.id === 'fotInCategory') && record[column.id].value < 50,
                                      // 'c-table__cell__green': (column.id === 'fotFromProceeds' || column.id === 'fotInCategory') && record[column.id].value > 50,
                                      "c-table__cell_string":
                                        column.type === "string",
                                      "c-table__cell_reference":
                                        column.type === "reference",
                                      "c-table__cell_number":
                                        column.type === "number",
                                      "c-table__cell_date":
                                        column.type === "date",
                                      "c-table__cell_hidden": _vm.isDisabled(
                                        column.id
                                      ),
                                      "c-table__cell_double_top_border":
                                        record.isSumRow !== undefined &&
                                        record.isSumRow,
                                      ["c-table__cell_" + column.id]: column.id,
                                    },
                                    style: {
                                      "background-color":
                                        column.id === "fotFromProceeds" ||
                                        column.id === "fotInCategory" ||
                                        column.id == "productionRate"
                                          ? _vm.getColorForPercentage(
                                              record[column.id].value,
                                              column.id
                                            )
                                          : "",
                                    },
                                  },
                                  [
                                    column.id === "load"
                                      ? _c("c-table-load-cell", {
                                          attrs: { record: record },
                                          on: { loadvalue: _vm.loadvalue },
                                        })
                                      : column.id === "additionalLoad"
                                      ? _c("c-table-additional-load-cell", {
                                          attrs: { record: record },
                                          on: { salmon: _vm.salmon },
                                        })
                                      : column.id === "lateness"
                                      ? _c("c-table-lateness-cell", {
                                          attrs: {
                                            "calc-data": _vm.calcData,
                                            record: record,
                                          },
                                        })
                                      : _c(
                                          "div",
                                          {
                                            staticClass: "c-table__cell-value",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                record[column.id].value
                                              ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  record[column.id].value
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                                _vm._l(
                                  record[column.id].values,
                                  function (rec) {
                                    return _c(
                                      "td",
                                      {
                                        key: `${rec.value}-record`,
                                        staticClass: "c-table__cell",
                                        class: {
                                          "c-table__cell_string":
                                            column.type === "string",
                                          "c-table__cell_reference":
                                            column.type === "reference",
                                          "c-table__cell_number":
                                            column.type === "number",
                                          "c-table__cell_date":
                                            column.type === "date",
                                          "c-table__cell_hidden":
                                            _vm.isDisabled(column.id),
                                          "c-table__cell_vertical_align":
                                            _vm.data.type === "main-factors" &&
                                            record[column.id].values[0]
                                              .countIntervals,
                                          ["c-table__cell_" + column.id]:
                                            column.id,
                                        },
                                        attrs: { rowspan: rec.rowspan },
                                      },
                                      [
                                        record[column.id] &&
                                        record[column.id].values &&
                                        rec.value
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__cell-values",
                                                domProps: {
                                                  innerHTML: _vm._s(rec.value),
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " + _vm._s(rec.value) + " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                              ]
                            }
                          ),
                          _vm.data.actions
                            ? _c(
                                "td",
                                {
                                  staticClass:
                                    "c-table__cell c-table__cell_actions",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "c-table__cell-actions" },
                                    [
                                      _vm.data.type === "main-factors"
                                        ? _c("c-table-main-factors-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type === "finance"
                                        ? _c("c-table-finance-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                      "inventory-items-positions"
                                        ? _c(
                                            "c-table-inventory-items-actions",
                                            { attrs: { record: record } }
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._l(_vm.sortedRecords, function (group, groupIndex) {
                return _c(
                  "tbody",
                  {
                    key: `${groupIndex}-records-group`,
                    staticClass: "c-table__records",
                  },
                  [
                    _vm.data.isGroupByCategory
                      ? [
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle",
                                  value: `category-collapse-${_vm.id}-${groupIndex}`,
                                  expression:
                                    "`category-collapse-${id}-${groupIndex}`",
                                },
                              ],
                              staticClass: "c-table__record",
                            },
                            [
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "c-table__cell__collapse__button",
                                  class: {
                                    "c-table__cell__collapse__button__docs":
                                      _vm.data.type ===
                                        "documents-acting-documents" ||
                                      _vm.data.type === "documents-archive",
                                  },
                                  style: {
                                    "border-bottom":
                                      _vm.sortedRecords.length ===
                                      groupIndex + 1
                                        ? "solid 1px #DFE4EF !important"
                                        : "",
                                  },
                                  attrs: {
                                    colspan:
                                      _vm.getTableColumns(_vm.levels).length +
                                      (_vm.data.actions ? 1 : 0),
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      staticClass:
                                        "c-table__cell__collapse__button__icon",
                                      attrs: {
                                        width: "22",
                                        height: "22",
                                        viewBox: "0 0 22 22",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "11",
                                          cy: "11",
                                          r: "10.5",
                                          fill: "white",
                                          stroke: "#DFE4EF",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                                          fill: "#0066FF",
                                        },
                                      }),
                                      _c("path", {
                                        attrs: {
                                          d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                                          fill: "#0066FF",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "c-table__cell__collapse__button__category__name",
                                    },
                                    [_vm._v(_vm._s(group.categoryName))]
                                  ),
                                  _vm.data.type ===
                                    "documents-acting-documents" ||
                                  _vm.data.type === "documents-archive"
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "c-table__cell__collapse__button__category__count",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(group.records.length) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("div", {
                                    staticClass:
                                      "c-table__cell__collapse__button__border__right",
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._l(group.records, function (record, recordIndex) {
                            return _c(
                              "b-collapse",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: record.isShowRow,
                                    expression: "record.isShowRow",
                                  },
                                ],
                                key: recordIndex,
                                staticClass: "c-table__record",
                                attrs: {
                                  id: `category-collapse-${_vm.id}-${groupIndex}`,
                                  tag: "tr",
                                  visible: "",
                                },
                              },
                              [
                                record.isShowRow
                                  ? [
                                      _vm._l(
                                        _vm.getTableColumns(_vm.levels),
                                        function (column, cellIndex) {
                                          return _c(
                                            "td",
                                            {
                                              key: `${column.id}-${cellIndex}`,
                                              staticClass: "c-table__cell",
                                              class: {
                                                "c-table__cell_string":
                                                  column.type === "string",
                                                "c-table__cell_reference":
                                                  column.type === "reference",
                                                "c-table__cell_number":
                                                  column.type === "number",
                                                "c-table__cell_date":
                                                  column.type === "date",
                                                "c-table__cell_hidden":
                                                  _vm.isDisabled(column.id),
                                                ["c-table__cell_" + column.id]:
                                                  column.id,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__cell-value",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      record[column.id].value
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      record[column.id].value
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm.data.actions
                                        ? _c(
                                            "td",
                                            {
                                              staticClass:
                                                "c-table__cell c-table__cell_actions",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "c-table__cell-actions",
                                                },
                                                [
                                                  _vm.data.type ===
                                                  "inventory-items-positions"
                                                    ? _c(
                                                        "c-table-inventory-items-actions",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                          },
                                                        }
                                                      )
                                                    : _vm._e(),
                                                  _vm.data.type ===
                                                    "documents-acting-documents" ||
                                                  _vm.data.type ===
                                                    "documents-archive"
                                                    ? _c(
                                                        "c-table-documents-actions",
                                                        {
                                                          attrs: {
                                                            record: record,
                                                            "record-id": `${groupIndex}-${recordIndex}`,
                                                            "table-type":
                                                              _vm.data.type,
                                                          },
                                                        }
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          }),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
            ],
            2
          ),
        ]
      ),
      _vm.data.records.length === 0
        ? _c("div", { staticClass: "c-table__empty__records" }, [
            _vm._v(_vm._s(_vm.emptyRecordsLabel)),
          ])
        : _vm._e(),
      !_vm.data.isGroupByCategory && _vm.data.records.length > 0
        ? _c(
            "div",
            { staticClass: "c-table__container__mobile" },
            [
              _c(
                "div",
                {
                  staticClass: "c-table__container__mobile__fixed__th",
                  attrs: { id: "tableMobileFixed" + _vm.id },
                },
                [
                  _c(
                    "table",
                    { ref: "container" },
                    [
                      _vm._l(
                        _vm.getColumns(_vm.data.levels),
                        function (column, recordIndex) {
                          return [
                            column.colspan === 1
                              ? _c(
                                  "tr",
                                  {
                                    key: `${recordIndex}-column`,
                                    staticClass: "c-table__record",
                                  },
                                  [
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "c-table__column c-table__column__mobile",
                                        class: {
                                          "c-table__column_sorted":
                                            _vm.isSorted(column),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__column-wrapper c-table__column-wrapper-mobile",
                                            class: {
                                              "c-table__column-wrapper-mobile-main-factors":
                                                _vm.data.type ===
                                                "main-factors",
                                              "c-table__column-wrapper-mobile-finance":
                                                _vm.data.type === "finance",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.setSortedColumn(
                                                  column,
                                                  _vm.sortedColumn
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-label",
                                                class: `c-table__column-label-${column.id}`,
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(column.label) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.sortedRecords,
                                      function (record, recordIndex) {
                                        return [
                                          _c(
                                            "td",
                                            {
                                              key: recordIndex,
                                              staticClass: "c-table__cell",
                                              class: {
                                                "c-table__cell__border__none":
                                                  _vm.sortedRecords.length -
                                                    1 ===
                                                  recordIndex,
                                                "c-table__cell__move__in__company":
                                                  _vm.data.type ===
                                                  "move-in-company",
                                                "c-table__cell__red":
                                                  (column.id ===
                                                    "fotFromProceeds" ||
                                                    column.id ===
                                                      "fotInCategory") &&
                                                  record[column.id] < 50,
                                                "c-table__cell__green":
                                                  (column.id ===
                                                    "fotFromProceeds" ||
                                                    column.id ===
                                                      "fotInCategory") &&
                                                  record[column.id] > 50,
                                              },
                                            },
                                            [
                                              column.id === "load"
                                                ? _c("c-table-load-cell", {
                                                    attrs: { record: record },
                                                  })
                                                : column.id === "additionalLoad"
                                                ? _c(
                                                    "c-table-additional-load-cell",
                                                    {
                                                      attrs: { record: record },
                                                    }
                                                  )
                                                : column.id === "lateness"
                                                ? _c("c-table-lateness-cell", {
                                                    attrs: {
                                                      "calc-data": _vm.calcData,
                                                      record: record,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__cell-value",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          record[column.id]
                                                            .value
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record[column.id]
                                                              .value
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._l(column.colspan, function (row, ind) {
                              return _c(
                                "tr",
                                {
                                  key: `${recordIndex}-${ind}-rows`,
                                  staticClass: "c-table__record",
                                },
                                [
                                  column.colspan > 1
                                    ? [
                                        ind === 0
                                          ? _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                                attrs: {
                                                  rowspan: column.colspan,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper c-table__column-wrapper-mobile",
                                                    class: {
                                                      "c-table__column-wrapper-mobile-main-factors":
                                                        _vm.data.type ===
                                                        "main-factors",
                                                      "c-table__column-wrapper-mobile-finance":
                                                        _vm.data.type ===
                                                        "finance",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                        class: `c-table__column-label-${column.id}`,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          _vm.sortedRecords,
                                          function (record, recordIndex) {
                                            return [
                                              record[column.id].values[row - 1]
                                                .value
                                                ? _c(
                                                    "td",
                                                    {
                                                      key: `${recordIndex}-record-row`,
                                                      staticClass:
                                                        "c-table__cell",
                                                      class: {
                                                        "c-table__cell__border__none":
                                                          _vm.sortedRecords
                                                            .length -
                                                            1 ===
                                                          recordIndex,
                                                      },
                                                      attrs: {
                                                        colspan:
                                                          record[column.id]
                                                            .values[row - 1]
                                                            .rowspan,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-values",
                                                          class: {
                                                            "c-table__cell-value-nowrap":
                                                              _vm.data.type ===
                                                              "main-factors",
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .values[row - 1]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].values[
                                                                  row - 1
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                          ]
                        }
                      ),
                      _vm.data.actions
                        ? _c(
                            "tr",
                            {
                              staticClass: "c-table__record",
                              style: {
                                height:
                                  _vm.data.type === "main-factors"
                                    ? "34px"
                                    : "",
                              },
                            },
                            [
                              _c(
                                "th",
                                {
                                  staticClass: "c-table__column",
                                  attrs: { rowspan: _vm.levels },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "c-table__column-empty c-table__column-empty-mobile",
                                  }),
                                ]
                              ),
                              _vm._l(
                                _vm.sortedRecords,
                                function (record, recordIndex) {
                                  return _c(
                                    "td",
                                    {
                                      key: `${recordIndex}-sorted-record`,
                                      staticClass: "c-table__cell",
                                      class: {
                                        "c-table__cell__border__none":
                                          _vm.sortedRecords.length - 1 ===
                                          recordIndex,
                                      },
                                    },
                                    [
                                      _vm.data.type === "main-factors"
                                        ? _c("c-table-main-factors-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type === "finance"
                                        ? _c("c-table-finance-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                      "inventory-items-positions"
                                        ? _c(
                                            "c-table-inventory-items-actions",
                                            { attrs: { record: record } }
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
              _c(
                "perfect-scrollbar",
                {
                  staticClass: "c-table__container__mobile__scrolled__td",
                  attrs: {
                    id: "tableMobileScroll" + _vm.id,
                    options: {
                      useBothWheelAxes: false,
                      suppressScrollX: false,
                      suppressScrollY: true,
                    },
                    tag: "div",
                  },
                  on: {
                    scroll: function ($event) {
                      return _vm.setShadowTableMobile(_vm.id)
                    },
                  },
                },
                [
                  _c(
                    "table",
                    { ref: "container" },
                    [
                      _vm._l(
                        _vm.getColumns(_vm.data.levels),
                        function (column, recordIndex) {
                          return [
                            column.colspan === 1
                              ? _c(
                                  "tr",
                                  {
                                    key: `${recordIndex}-mobile-record`,
                                    staticClass: "c-table__record",
                                  },
                                  [
                                    _c(
                                      "th",
                                      {
                                        staticClass:
                                          "c-table__column c-table__column__mobile",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-table__column-wrapper c-table__column-wrapper-mobile",
                                            class: {
                                              "c-table__column-wrapper-mobile-main-factors":
                                                _vm.data.type ===
                                                "main-factors",
                                              "c-table__column-wrapper-mobile-finance":
                                                _vm.data.type === "finance",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "c-table__column-label",
                                                class: `c-table__column-label-${column.id}`,
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(column.label) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._l(
                                      _vm.sortedRecords,
                                      function (record, recordIndex) {
                                        return [
                                          _c(
                                            "td",
                                            {
                                              key: recordIndex,
                                              staticClass: "c-table__cell",
                                              class: {
                                                "c-table__cell__red":
                                                  (column.id ===
                                                    "fotFromProceeds" ||
                                                    column.id ===
                                                      "fotInCategory") &&
                                                  record[column.id] < 50,
                                                "c-table__cell__green":
                                                  (column.id ===
                                                    "fotFromProceeds" ||
                                                    column.id ===
                                                      "fotInCategory") &&
                                                  record[column.id] > 50,
                                              },
                                            },
                                            [
                                              column.id === "load"
                                                ? _c("c-table-load-cell", {
                                                    attrs: { record: record },
                                                  })
                                                : column.id === "additionalLoad"
                                                ? _c(
                                                    "c-table-additional-load-cell",
                                                    {
                                                      attrs: { record: record },
                                                    }
                                                  )
                                                : column.id === "lateness"
                                                ? _c("c-table-lateness-cell", {
                                                    attrs: {
                                                      "calc-data": _vm.calcData,
                                                      record: record,
                                                    },
                                                  })
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "c-table__cell-value",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          record[column.id]
                                                            .value
                                                        ),
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            record[column.id]
                                                              .value
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                            ],
                                            1
                                          ),
                                        ]
                                      }
                                    ),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _vm._l(column.colspan, function (row, ind) {
                              return _c(
                                "tr",
                                {
                                  key: `${recordIndex}-${ind}-mobile-record-col`,
                                  staticClass: "c-table__record",
                                },
                                [
                                  column.colspan > 1
                                    ? [
                                        ind === 0
                                          ? _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                                attrs: {
                                                  rowspan: column.colspan,
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                        class: `c-table__column-label-${column.id}`,
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          _vm.sortedRecords,
                                          function (record, recordIndex) {
                                            return [
                                              record[column.id].values[row - 1]
                                                .value
                                                ? _c(
                                                    "td",
                                                    {
                                                      key: `${recordIndex}-mobile-record-col-record`,
                                                      staticClass:
                                                        "c-table__cell",
                                                      attrs: {
                                                        colspan:
                                                          record[column.id]
                                                            .values[row - 1]
                                                            .rowspan,
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-values",
                                                          class: {
                                                            "c-table__cell-value-nowrap":
                                                              _vm.data.type ===
                                                              "main-factors",
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .values[row - 1]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].values[
                                                                  row - 1
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          }
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            }),
                          ]
                        }
                      ),
                      _vm.data.actions
                        ? _c(
                            "tr",
                            {
                              staticClass: "c-table__record",
                              style: {
                                height:
                                  _vm.data.type === "main-factors"
                                    ? "34px"
                                    : "",
                              },
                            },
                            [
                              _c(
                                "th",
                                {
                                  staticClass: "c-table__column",
                                  attrs: { rowspan: _vm.levels },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "c-table__column-empty c-table__column-empty-mobile",
                                  }),
                                ]
                              ),
                              _vm._l(
                                _vm.sortedRecords,
                                function (record, recordIndex) {
                                  return _c(
                                    "td",
                                    {
                                      key: `${recordIndex}-action-records`,
                                      staticClass: "c-table__cell",
                                    },
                                    [
                                      _vm.data.type === "main-factors"
                                        ? _c("c-table-main-factors-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type === "finance"
                                        ? _c("c-table-finance-actions", {
                                            attrs: { record: record },
                                          })
                                        : _vm._e(),
                                      _vm.data.type ===
                                      "inventory-items-positions"
                                        ? _c(
                                            "c-table-inventory-items-actions",
                                            { attrs: { record: record } }
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.data.isGroupByCategory && _vm.data.records.length > 0
        ? _c(
            "div",
            { ref: "container", staticClass: "c-table__container__mobile" },
            _vm._l(_vm.sortedRecords, function (group, groupIndex) {
              return _c(
                "div",
                { key: `${groupIndex}-mobile-category` },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle",
                          value: `category-collapse-${_vm.id}${groupIndex}`,
                          expression: "`category-collapse-${id}${groupIndex}`",
                        },
                      ],
                      staticClass:
                        "c-table__cell__collapse__button d-flex align-items-center shadow-none",
                      class: {
                        "c-table__cell__collapse__button__hide__borders":
                          groupIndex === 0,
                        "c-table__cell__collapse__button__hide__borders__last":
                          _vm.sortedRecords.length === groupIndex + 1,
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "c-table__cell__collapse__button__icon",
                          attrs: {
                            width: "22",
                            height: "22",
                            viewBox: "0 0 22 22",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "11",
                              cy: "11",
                              r: "10.5",
                              fill: "white",
                              stroke: "#D3D8DF",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z",
                              fill: "#0066FF",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z",
                              fill: "#0066FF",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "span",
                        {
                          staticClass:
                            "c-table__cell__collapse__button__category__name",
                        },
                        [_vm._v(_vm._s(group.categoryName))]
                      ),
                      _vm.data.type === "documents-acting-documents" ||
                      _vm.data.type === "documents-archive"
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "c-table__cell__collapse__button__category__count",
                            },
                            [_vm._v(" " + _vm._s(group.records.length) + " ")]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "c-table__mobile__collapse",
                      attrs: {
                        id: `category-collapse-${_vm.id}${groupIndex}`,
                        visible: "",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "c-table__container__mobile__fixed__th",
                          attrs: {
                            id: "tableMobileFixed" + _vm.id + groupIndex,
                          },
                        },
                        [
                          _c(
                            "table",
                            { ref: "container", refInFor: true },
                            [
                              _vm._l(
                                _vm.getColumns(_vm.data.levels),
                                function (column, recordIndex) {
                                  return [
                                    column.colspan === 1
                                      ? _c(
                                          "tr",
                                          {
                                            key: `${recordIndex}-mobile-category-column`,
                                            staticClass: "c-table__record",
                                          },
                                          [
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                                class: {
                                                  "c-table__column_sorted":
                                                    _vm.isSorted(column),
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper c-table__column-wrapper-mobile",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.setSortedColumn(
                                                          column,
                                                          _vm.sortedColumn
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._l(
                                              _vm.sortedRecords[groupIndex]
                                                .records,
                                              function (record, recordIndex) {
                                                return [
                                                  _c(
                                                    "td",
                                                    {
                                                      key: recordIndex,
                                                      staticClass:
                                                        "c-table__cell",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-value",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._l(column.colspan, function (row, ind) {
                                      return _c(
                                        "tr",
                                        {
                                          key: `mobile-${ind}-column`,
                                          staticClass: "c-table__record",
                                        },
                                        [
                                          column.colspan > 1
                                            ? [
                                                ind === 0
                                                  ? _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "c-table__column c-table__column__mobile",
                                                        attrs: {
                                                          rowspan:
                                                            column.colspan,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-table__column-wrapper",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-table__column-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      column.label
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._l(
                                                  _vm.sortedRecords[groupIndex]
                                                    .records,
                                                  function (
                                                    record,
                                                    recordIndex
                                                  ) {
                                                    return [
                                                      record[column.id].values[
                                                        row - 1
                                                      ].value
                                                        ? _c(
                                                            "td",
                                                            {
                                                              key: `mobile-${ind}-column-${recordIndex}`,
                                                              staticClass:
                                                                "c-table__cell",
                                                              attrs: {
                                                                colspan:
                                                                  record[
                                                                    column.id
                                                                  ].values[
                                                                    row - 1
                                                                  ].rowspan,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "c-table__cell-value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      record[
                                                                        column
                                                                          .id
                                                                      ].values[
                                                                        row - 1
                                                                      ].value
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }),
                                  ]
                                }
                              ),
                              _vm.data.actions
                                ? _c(
                                    "tr",
                                    {
                                      staticClass: "c-table__record",
                                      style: {
                                        height:
                                          _vm.data.type === "main-factors"
                                            ? "34px"
                                            : "",
                                      },
                                    },
                                    [
                                      _c(
                                        "th",
                                        {
                                          staticClass: "c-table__column",
                                          attrs: { rowspan: _vm.levels },
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-table__column-empty c-table__column-empty-mobile",
                                          }),
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.sortedRecords[groupIndex].records,
                                        function (record, recordIndex) {
                                          return _c(
                                            "td",
                                            {
                                              key: `action-${recordIndex}`,
                                              staticClass: "c-table__cell",
                                              class: {
                                                "c-table__cell__move__in__company":
                                                  _vm.data.type ===
                                                  "move-in-company",
                                              },
                                            },
                                            [
                                              _vm.data.type ===
                                                "documents-acting-documents" ||
                                              _vm.data.type ===
                                                "documents-archive"
                                                ? _c(
                                                    "c-table-documents-actions",
                                                    {
                                                      attrs: {
                                                        record: record,
                                                        "record-id": `hidden-${groupIndex}-${recordIndex}`,
                                                        "table-type":
                                                          _vm.data.type,
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "perfect-scrollbar",
                        {
                          staticClass:
                            "c-table__container__mobile__scrolled__td",
                          attrs: {
                            id: "tableMobileScroll" + _vm.id + groupIndex,
                            options: {
                              useBothWheelAxes: false,
                              suppressScrollX: false,
                              suppressScrollY: true,
                            },
                            tag: "div",
                          },
                          on: {
                            scroll: function ($event) {
                              return _vm.setShadowTableMobile(
                                _vm.id + groupIndex
                              )
                            },
                          },
                        },
                        [
                          _c(
                            "table",
                            { ref: "container", refInFor: true },
                            [
                              _vm._l(
                                _vm.getColumns(_vm.data.levels),
                                function (column, recordIndex) {
                                  return [
                                    column.colspan === 1
                                      ? _c(
                                          "tr",
                                          {
                                            key: `${recordIndex}-column-${groupIndex}`,
                                            staticClass: "c-table__record",
                                          },
                                          [
                                            _c(
                                              "th",
                                              {
                                                staticClass:
                                                  "c-table__column c-table__column__mobile",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "c-table__column-wrapper c-table__column-wrapper-mobile",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "c-table__column-label",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              column.label
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._l(
                                              _vm.sortedRecords[groupIndex]
                                                .records,
                                              function (record, recordIndex) {
                                                return [
                                                  _c(
                                                    "td",
                                                    {
                                                      key: recordIndex,
                                                      staticClass:
                                                        "c-table__cell",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "c-table__cell-value",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              record[column.id]
                                                                .value
                                                            ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                record[
                                                                  column.id
                                                                ].value
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              }
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    _vm._l(column.colspan, function (row, ind) {
                                      return _c(
                                        "tr",
                                        {
                                          key: `${ind}-column-${groupIndex}`,
                                          staticClass: "c-table__record",
                                        },
                                        [
                                          column.colspan > 1
                                            ? [
                                                ind === 0
                                                  ? _c(
                                                      "th",
                                                      {
                                                        staticClass:
                                                          "c-table__column c-table__column__mobile",
                                                        attrs: {
                                                          rowspan:
                                                            column.colspan,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "c-table__column-wrapper",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "c-table__column-label",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      column.label
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._l(
                                                  _vm.sortedRecords[groupIndex]
                                                    .records,
                                                  function (
                                                    record,
                                                    recordIndex
                                                  ) {
                                                    return [
                                                      record[column.id].values[
                                                        row - 1
                                                      ].value
                                                        ? _c(
                                                            "td",
                                                            {
                                                              key: `${recordIndex}-move-in-company`,
                                                              staticClass:
                                                                "c-table__cell",
                                                              class: {
                                                                "c-table__cell__move__in__company":
                                                                  _vm.data
                                                                    .type ===
                                                                  "move-in-company",
                                                              },
                                                              attrs: {
                                                                colspan:
                                                                  record[
                                                                    column.id
                                                                  ].values[
                                                                    row - 1
                                                                  ].rowspan,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "c-table__cell-value",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      record[
                                                                        column
                                                                          .id
                                                                      ].values[
                                                                        row - 1
                                                                      ].value
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  }
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }),
                                  ]
                                }
                              ),
                              _vm.data.actions
                                ? _c(
                                    "tr",
                                    {
                                      staticClass: "c-table__record",
                                      style: {
                                        height:
                                          _vm.data.type === "main-factors"
                                            ? "34px"
                                            : "",
                                      },
                                    },
                                    [
                                      _c(
                                        "th",
                                        { staticClass: "c-table__column" },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "c-table__column-empty c-table__column-empty-mobile",
                                          }),
                                        ]
                                      ),
                                      _vm._l(
                                        _vm.sortedRecords[groupIndex].records,
                                        function (record, recordIndex) {
                                          return _c(
                                            "td",
                                            {
                                              key: `main-factors-${recordIndex}`,
                                              staticClass: "c-table__cell",
                                            },
                                            [
                                              _vm.data.type ===
                                                "documents-acting-documents" ||
                                              _vm.data.type ===
                                                "documents-archive"
                                                ? _c(
                                                    "c-table-documents-actions",
                                                    {
                                                      attrs: {
                                                        "record-id": `mobile-${groupIndex}-${recordIndex}`,
                                                        record: record,
                                                        "table-type":
                                                          _vm.data.type,
                                                      },
                                                    }
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }